import React from 'react';

import { ShapeMultipleIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';

import MarkupsEntityBlock from './MarkupsEntityBlock';
import MarkupsEntityMenuItem from './MarkupsEntityMenuItem';
import ReferencePickerPlugin from '../../../types/ReferencePickerPlugin';
import { services } from '../helpers/sdkServicesMarkup';
import { chunk, formatSheetHistory } from '../helpers/utils';
import { SheetHistory, Sheet } from '../types/types';

const markupsOnSheetsPlugin: ReferencePickerPlugin<Sheet> = {
  metadata: {
    domain: 'autodesk-construction-markup',
    type: 'markupsheethistory',
  },
  renderIcon: (p) => <ShapeMultipleIcon {...p} />,
  PluralText: ({ lowerCase }) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
    const result = T.translate('MARKUPS');
    return lowerCase && typeof result === 'string'
      ? result.toLowerCase()
      : result;
  },
  // Get sheet histories for linked sheets
  getEntitiesByIds: async ({ projectId, ids }) => {
    let data: Sheet[] = [];
    await chunk(ids, 50).reduce((pre, resources) => {
      return pre.then(() =>
        services.Sheets.getSheetsHistories(projectId, {
          ids: resources,
          versionLimit: 1,
          collectionId: '*',
        }).then((res: SheetHistory[]) => {
          const versions: Sheet[] = res.flatMap(({ versions }) =>
            versions.map(formatSheetHistory),
          );
          data = [...data, ...versions];
        }),
      );
    }, Promise.resolve());
    return { data };
  },
  EntityBlock: MarkupsEntityBlock,
  EntityMenuItem: MarkupsEntityMenuItem,
};

export default markupsOnSheetsPlugin;
